import React from 'react'
import { motion } from 'framer-motion'

import tata from '../../assets/tata.png'
import bosch from '../../assets/bosch.png'
import lt from '../../assets/lt.jpg'
import tech from '../../assets/tech.png'
import quest from '../../assets/quest.jpg'
import hcl from '../../assets/hcl.png'
import hinduja from '../../assets/hinduja.jpeg'
import caresoft from '../../assets/caresoft.png'
import bull from '../../assets/bull.png'
import tafe from '../../assets/tafe.jpg'
import chi from '../../assets/chi.png'
import idc from '../../assets/idc.png'
import ari from '../../assets/ari.png'
import satven from '../../assets/satven.png'


const partners = [
    tata, bosch, lt, tech, quest, hcl, hinduja,
    caresoft, bull, tafe, chi, idc, ari, satven
]

const scrollSpeed = 20

const ScrollingRow = ({ logos, reverse = false }) => {
    const duplicated = [...logos, ...logos]

    return (
        <div className="overflow-hidden w-full">
            <motion.div
                className="flex gap-9 py-6"
                initial={{ x: 0 }}
                animate={{ x: reverse ? ['0%', '-50%'] : ['-50%', '0%'] }}
                transition={{ repeat: Infinity, duration: scrollSpeed, 'ease': 'linear' }}
                whileHover={{ scale: 1.02 }}>
                {duplicated.map((logo, i) => (
                    <div key={i} className="flex-shrink-0 px-3">
                        <img src={logo} alt="partner" className="w-[140px] sm:w-[120px] h-[70px] object-contain" /></div>
                ))}
            </motion.div>
        </div>
    )
}

export default function OurClients() {
    const firstRow = partners.slice(0, 7)
    const secondRow = partners.slice(7, 14)

    return (
        <div>
            <section className="bg-white  px-4 sm:px-10 lg:px-20 max-w-7xl mx-auto py-10">
                <h2 className="text-3xl md:text-4xl font-bold text-center ">
                    Our Clients
                </h2>

                <div className="space-y-10">
                    <ScrollingRow logos={firstRow} reverse={false} />
                    <ScrollingRow logos={secondRow} reverse={true} />
                </div>

            </section>

        </div>
    )
}
